import { LegacyPopoverInitializer } from './legacy-popover-initializer'

export default LegacyPopoverInitializer
